import { ReceiverItem } from "./type/receiver-item.interface";

export class SMSFieldsData {
  constructor(
    public receivers: (string | ReceiverItem)[],
    public message: string,
    public signature: string
  ) {}
}
